/* eslint-disable @typescript-eslint/naming-convention */
export enum FormControlTypeEnum {
	Textbox = 'Textbox',
	Numeric = 'Numeric',
	Textarea = 'Textarea',
	Dropdown = 'Dropdown',
	DatePicker = 'DatePicker',
	TimePicker = 'TimePicker',
	CheckBox = 'CheckBox',
	Formula = 'Formula',
	Signature = 'Signature',
	Gps = 'Gps'
}
